import { LAZY_LOAD_BEGINS_AT } from '../constants';

export default function getLazyLoadStartingPoint({ isMobile, isTablet }) {
    if (isMobile) {
        return LAZY_LOAD_BEGINS_AT.MOBILE;
    } else {
        return isTablet ? LAZY_LOAD_BEGINS_AT.TABLET : LAZY_LOAD_BEGINS_AT.DESKTOP;
    }
}
